// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"vacant_btn-container__1_Uqm","heading":"vacant_heading__1DMBw","refresh-btn":"vacant_refresh-btn__3jGaB","upload-history-btn":"vacant_upload-history-btn__1F-by"};